import { render, staticRenderFns } from "./dic_defects_list.vue?vue&type=template&id=797ad442&scoped=true"
import script from "./dic_defects_list.vue?vue&type=script&lang=js"
export * from "./dic_defects_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797ad442",
  null
  
)

export default component.exports